module.exports = __webpack_public_path__ + "img/poor_man's_shield.79355950.png";